import Feature8 from './Feature8'
export default Feature8
